import _ from 'lodash';
import React from 'react';
import { useChangeAwareEffect } from 'use-change-aware-effect';
import { ThemeProvider } from 'styled-components';
import theme from '../../../../assets/stylesheets/_settings.global.scss';
import Loading from '../../../shared/loading';
import { Container, ContentContainer } from '../shared/styles';
import { useGetAnnouncements } from '../../../services/lwadmin/announcement/announcement-service';
import Announcement from './announcements-components/announcement';
import Actions from './announcements-components/actions';
import Header from './announcements-components/header';
import AnnouncementModal from '../../announcement/announcement-modal';
import useAnnouncementModalStore from '../../announcement/state-hook';

export default function Announcements() {
  const [announcements, setAnnouncements] = React.useState([]);
  const [{ loading }, get] = useGetAnnouncements();
  const loadingRef = React.useRef();

  const announcement = useAnnouncementModalStore(state => state.currentAnnouncement);

  useChangeAwareEffect(({ isMount }) => {
    isMount && get().then(({ data }) => setAnnouncements(_.get(data, 'announcements', [])));
  }, {});

  React.useEffect(() => (loadingRef.current.toggle(loading)), [loading]);

  return (
    <ThemeProvider theme={theme}>
      <Container>
        <ContentContainer>
          <h1>Announcements</h1>
          <Header />
          <Loading ref={loadingRef}>
            {announcements.map(an => <Announcement key={an.id} announcement={an} />)}
          </Loading>
        </ContentContainer>
        <Actions />
      </Container>
      <AnnouncementModal announcement={announcement} preview />
    </ThemeProvider>
  );
}
